import React from "react";
import PropTypes from "prop-types";
import styles from "./Skill.css";
import Rating from "./Rating/Rating";

const Skill = ({ title, rating }) => (
  <div className={styles.Skill}>
    <div className={[styles.SkillHeading, styles.clearfix].join(" ")}>
      <span className={styles.SkillTitle}>{title}</span>
      <span className={styles.Rating}>
        <Rating rating={rating} />
      </span>
    </div>
  </div>
);

Skill.propTypes = {
  title: PropTypes.string.isRequired,
  rating: PropTypes.string.isRequired
};

export default Skill;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Resume/Skills/Skill/Skill.js